import { render } from "./vsupplieradd.vue?vue&type=template&id=31a771f8&scoped=true"
import script from "./vsupplieradd.vue?vue&type=script&lang=js"
export * from "./vsupplieradd.vue?vue&type=script&lang=js"

import "./vsupplieradd.vue?vue&type=style&index=0&id=31a771f8&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a771f8"]])

export default __exports__